import { render, staticRenderFns } from "./zhuangXianSetting.vue?vue&type=template&id=683ca35d&scoped=true"
import script from "./zhuangXianSetting.vue?vue&type=script&lang=js"
export * from "./zhuangXianSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ca35d",
  null
  
)

export default component.exports